import React from 'react'
import First from './tabs/first';
import Second from './tabs/second';

function Tabs({Tab,reason, setReason,setWords,Words, setReasonType, reasonType}) {

  return (
    <div>
      {Tab === 1 && <First reason={reason}setReason={setReason}setReasonType={setReasonType} reasonType={reasonType}/>}
      {Tab === 2 && <Second setWords={setWords} Words={Words}/>}
    </div>
  )
}

export default Tabs